<template>
  <section>
    <div class="oa-nav">
      <router-link to="/m/Personnel/Vacation/List">
        <div class="nav-item">
          <span class="iconfont icon-wj-qjd"></span>
          <span class="title">请假调休</span>
        </div>
      </router-link>
      <router-link to="/m/Notice/List">
        <div class="nav-item">
          <span class="iconfont icon-tongzhi"></span>
          <span class="title">通知公告</span>
        </div>
      </router-link>
      <router-link to="/m/Meeting/List">
        <div class="nav-item">
          <span class="iconfont icon-huiyishi"></span>
          <span class="title">我的会议</span>
          <span v-if="tipNum.conferenceNum" class="nav-item-num">{{ tipNum.conferenceNum }}</span>
        </div>
      </router-link>
      <router-link to="/m/Project/List">
        <div class="nav-item">
          <span class="iconfont icon-xiangmuguanli"></span>
          <span class="title">我的工程</span>
        </div>
      </router-link>
      <router-link to="/m/Contract/List">
        <div class="nav-item">
          <span class="iconfont icon-hetong"></span>
          <span class="title">我的合同</span>
        </div>
      </router-link>
      <router-link to="/m/Approval/List">
        <div class="nav-item">
          <span class="iconfont icon-shenpi"></span>
          <span class="title">我的审批</span>
          <span v-if="tipNum.spNum" class="nav-item-num">{{ tipNum.spNum }}</span>
        </div>
      </router-link>

    </div>
  </section>
</template>
<script>
  export default {
    data() {
      return {
        tipNum: "",
      }
    },
    mounted() {
      this.getTipsNum()
    },
    methods: {
      // 获取最新的会议条数及审批条数
      getTipsNum() {
        ajax.get('/msg/tips/num', "", (res) => {
          this.tipNum = res.vo
        })
      },
    },
    watch: {}
  }
</script>


// WEBPACK FOOTER //
// src/page/m/index.vue